import { renderSlot as _renderSlot, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["TooltipPortal"], null, {
        default: _withCtx(() => [
            _createVNode($setup["TooltipContent"], _mergeProps({ "data-slot": "tooltip-content" }, { ...$setup.forwarded, ..._ctx.$attrs }, {
                class: $setup.cn('bg-en-blue-400 backdrop-blur-sm text-background shadow-lg animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-[3000] w-fit rounded-md px-3 py-1.5 text-xs text-balance', $setup.props.class)
            }), {
                default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default"),
                    _createVNode($setup["TooltipArrow"], { class: "bg-en-blue-400 fill-en-blue-400 z-50 size-2.5 translate-y-[calc(-50%_-_2px)] rotate-45 rounded-xs" })
                ]),
                _: 3 /* FORWARDED */
            }, 16 /* FULL_PROPS */, ["class"])
        ]),
        _: 3 /* FORWARDED */
    }));
}
